export const soilTypeIndexLabelMap: {[key: number]: string} = {
    0: "0:畑（黒ボク土）・生土",
    1: "1:畑（普通土）・生土",
    2: "2:畑（粘土）・生土",
    3: "3:水田・生土",
    4: "4:畑（黒ボク土）・乾土",
    5: "5:畑（普通土）・乾土",
    6: "6:畑（粘土）・乾土",
    7: "7:水田・乾土"
};

export const deleteFlagLabelMap: {[key: string]: string} = {
    true: "端末上のデータは削除済み",
    false: ""
};

export const dilutionRateLabelMap: {[value: number]: string} = {
    2: "1/3",
    3: "1/2",
    6: "1.0",
    12: "2.0",
    18: "3.0"
};
